<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Master Ekspedisi/Pengiriman Koran
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :fields="tblFields"
        :items="data"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template
          v-slot:cell(startdate_contract)="data"
        >{{data.item.startdate_contract | moment('DD MMMM YYYY')}}</template>
        <template
          v-slot:cell(enddate_contract)="data"
        >{{data.item.enddate_contract | moment('DD MMMM YYYY')}}</template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click.stop="deleteConfirm(data.item)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Ekspedisi/Pengiriman Koran - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Ekspedisi</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.ekspedisi_name"
              :state="!$v.frmdata.ekspedisi_name.$error"
              placeholder="Nama ekspedisi"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama kontak</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.contact_name"
              :state="!$v.frmdata.contact_name.$error"
              placeholder="Nama kontak"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No. Kontak</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.contact_number"
              :state="!$v.frmdata.contact_number.$error"
              placeholder="No. kontak"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Kontrak</label>
            </b-input-group-prepend>
            <b-row>
              <b-col md="6">
                <b-input-group>
                  <b-form-input
                    type="date"
                    v-model="frmdata.startdate_contract"
                    :state="!$v.frmdata.startdate_contract.$error"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button size="sm" text="Button" variant="secondary" @click="startdate = null">
                      <span class="fa fa-close"></span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col md="6">
                <b-input-group>
                  <b-form-input
                    type="date"
                    v-model="frmdata.enddate_contract"
                    :state="!$v.frmdata.enddate_contract.$error"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" text="Button" variant="secondary" @click="enddate = null">
                      <span class="fa fa-close"></span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      ekspedisi_name: { required },
      contact_name: { required },
      contact_number: { required },
      startdate_contract: { required },
      enddate_contract: { required }
    }
  },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList: true,
      showForm: false,
      frmdata: {
        ekspedisi_name: "",
        contact_name: null,
        contact_number: null,
        startdate_contract: null,
        enddate_contract: null
      },
      tblFields: [
        {
          key: "ekspedisi_name",
          label: "Expedition Name",
          sortable: true
        },
        {
          key: "contact_name",
          label: "Contact Name",
          sortable: true
        },
        {
          key: "contact_number",
          label: "Contact Number",
          sortable: true
        },
        {
          key: "startdate_contract",
          label: "Awal Kontrak",
          sortable: true
        },
        {
          key: "enddate_contract",
          label: "Akhir Kontrak",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center"
        }
      ],
      tblData: {
        tablename: "koranekspedisi",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      startdate: null,
      enddate: null
    };
  },
  computed: {
    // tblFields() {
    //   const fields = [
    //     {
    //       key: "ekspedisi_name",
    //       label: "Expedition Name",
    //       sortable: true
    //     },
    //     {
    //       key: "contact_name",
    //       label: "Contact Name",
    //       sortable: true
    //     },
    //     {
    //       key: "contact_number",
    //       label: "Contact Number",
    //       sortable: true
    //     },
    //     {
    //       key: "action",
    //       label: "Action",
    //       thStyle: "width:60px",
    //       thClass: "text-center"
    //     }
    //   ];
    //   return fields;
    // },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  watch: {
    startdate(val) {
      console.log("val startdate", val);
      if (val !== null)
        this.frmdata.startdate_contract = moment(val).format("YYYY-MM-DD");
      else this.frmdata.startdate_contract = null;
    },
    enddate(val) {
      if (val !== null)
        this.frmdata.enddate_contract = moment(val).format("YYYY-MM-DD");
      else this.frmdata.enddate_contract = null;
    }
  },
  methods: {
    formatDate(val) {
      if (val !== "") {
        let date = new Date(val);
        return moment(date).format("DD MMMM YYYY");
      } else {
        return null;
      }
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      console.log("data", data);
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.ekspedisi_id;
      this.startdate = data.startdate_contract
        ? new Date(data.startdate_contract)
        : null;
      this.enddate = data.enddate_contract
        ? new Date(data.enddate_contract)
        : null;

      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.idlama) {
            await crud.update({
              tablename: "koranekspedisi",
              key: this.frmdata.idlama,
              data: {
                ekspedisi_name: this.frmdata.ekspedisi_name,
                contact_name: this.frmdata.contact_name,
                contact_number: this.frmdata.contact_number,
                startdate_contract: this.frmdata.startdate_contract,
                enddate_contract: this.frmdata.enddate_contract
              }
            });
          } else {
            await crud.insert({
              tablename: "koranekspedisi",
              data: {
                ekspedisi_name: this.frmdata.ekspedisi_name,
                contact_name: this.frmdata.contact_name,
                contact_number: this.frmdata.contact_number,
                startdate_contract: this.frmdata.startdate_contract,
                enddate_contract: this.frmdata.enddate_contract
              }
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({
        tablename: "koranekspedisi",
        key: this.model.ekspedisi_id
      });
      this.refresh();
    },
    rowClicked(record, index) {
      console.log("rowClicked");
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
        this.showForm = true;
        this.showList = false;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
